<script setup lang="ts">
import { useFlowEditorContext } from '../../composables/useFlowEditor'
import ActionNodeSettings from './ActionNodeSettings.vue'
import ConditionNodeSettings from './ConditionNodeSettings.vue'
import MacroNodeSettings from './MacroNodeSettings.vue'
import MediaActionSettings from './MediaActionSettings.vue'
import RegisterActionSettings from './RegisterActionSettings.vue'

/** Settings of the selected node (common fields; type-specific sections below). */
const editor = useFlowEditorContext()
const { selectedNode, selectedEdgeId } = editor.selection
const { groupOptions, nodeTypeLabel } = editor
const { debounced: di, flush: db, updateNodeLabel, updatePhaseId, updateGroupId } = editor.inspector
const { removeNode, removeSelectedEdge } = editor.editing
</script>

<template>
  <div>
    <div v-if="selectedNode" class="flow-settings__panel">
      <label>
        <span>{{ $t('flow.nodeLabel') }}</span>
        <input
          :value="selectedNode.label"
          type="text"
          @input="di(updateNodeLabel)($event)"
          @blur="db(updateNodeLabel)($event)"
        />
      </label>

      <div class="flow-settings__meta">
        {{ $t('flow.typeLabel') }}: {{ nodeTypeLabel(selectedNode.type) }}
      </div>

      <label v-if="selectedNode.type === 'phase'">
        <span>{{ $t('flow.phaseId') }}</span>
        <input
          :value="selectedNode.data.phaseId || ''"
          type="text"
          @input="di(updatePhaseId)($event)"
          @blur="db(updatePhaseId)($event)"
        />
      </label>

      <label v-if="selectedNode.type === 'group'">
        <span>{{ $t('flow.group') }}</span>
        <select
          :value="selectedNode.data.groupId"
          @change="updateGroupId(($event.target as HTMLSelectElement).value)"
        >
          <option value="__all__">{{ $t('flow.allCardsDeck') }}</option>
          <option v-for="group in groupOptions" :key="group.id" :value="group.id">
            {{ group.title || group.id }}
          </option>
        </select>
      </label>

      <MacroNodeSettings :selected-node="selectedNode" />
      <ConditionNodeSettings :selected-node="selectedNode" />
      <ActionNodeSettings :selected-node="selectedNode" />
      <MediaActionSettings :selected-node="selectedNode" />
      <RegisterActionSettings :selected-node="selectedNode" />

      <button type="button" class="pl-btn pl-btn--danger" @click="removeNode(selectedNode.id)">
        {{ $t('flow.deleteNode') }}
      </button>
    </div>

    <div v-else-if="selectedEdgeId" class="flow-settings__panel">
      <div class="flow-settings__meta">
        {{ $t('flow.selectedConnection') }}: {{ selectedEdgeId }}
      </div>
      <button type="button" class="pl-btn pl-btn--danger" @click="removeSelectedEdge">
        {{ $t('flow.deleteConnection') }}
      </button>
    </div>

    <div v-else class="flow-settings__empty">{{ $t('flow.selectNodeOrConnection') }}</div>
  </div>
</template>

<style scoped src="../styles/inspectorForm.css"></style>
